import * as z from 'zod'
import {BasePayloadSchema} from './base-payload'
import {BreadcrumbSchema} from './breadcrumb'

/**
 * Payload schema for individual resource detail pages.
 */
export const ResourceDetailsPayloadSchema = z.lazy(() =>
  BasePayloadSchema.unwrap().extend({
    breadcrumbLinks: z.array(BreadcrumbSchema).optional(),
    indexPath: z.string().optional(),
  }),
)

export type ResourceDetailsPayload = z.infer<typeof ResourceDetailsPayloadSchema>

export function toResourceDetailsPayload(payload: unknown): ResourceDetailsPayload {
  return ResourceDetailsPayloadSchema.parse(payload)
}
